import { CircleNotch } from "@phosphor-icons/react";
import { Wordmark } from "@/components/Wordmark";

export const FullScreenLoader = ({ label = "Loading" }) => (
  <div data-testid="fullscreen-loader" className="min-h-screen flex flex-col items-center justify-center gap-4 bg-slate-50 blueprint-grid">
    <Wordmark />
    <div className="flex items-center gap-2 text-sm text-slate-500">
      <CircleNotch className="animate-spin" size={16} /> {label}…
    </div>
  </div>
);
